{
  "status": {
    "DRAFT": "Draft",
    "POSTED": "Posted",
    "VOID": "Void"
  },
  "payment": {
    "UNPAID": "Unpaid",
    "PARTIAL": "Part paid",
    "PAID": "Paid",
    "OVERDUE": "Overdue",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days"
  },
  "kind": {
    "INVOICE": "Invoice",
    "DEBIT_NOTE": "Debit note"
  },
  "fields": {
    "customer": "Customer",
    "reference": "Reference",
    "notes": "Notes",
    "number": "Number",
    "kind": "Type",
    "date": "Date",
    "total": "Total",
    "status": "Status",
    "journalEntry": "Journal entry",
    "viewEntry": "View journal entry",
    "posted": "Posted",
    "notPostedYet": "Not posted yet",
    "noEntry": "None (voided)",
    "updatedAt": "Last changed"
  },
  "list": {
    "clearSearch": "Clear search",
    "emptyFiltered": "Nothing matches these filters.",
    "emptyFilteredBody": "Try another search, customer or period.",
    "clearFilters": "Clear filters",
    "customerFilter": "Filter by customer",
    "allCustomers": "All customers",
    "statusFilter": "Filter by status",
    "allStatuses": "All statuses"
  },
  "form": {
    "saveHint": "Press {{shortcut}} to save",
    "shortcuts": "{{save}} saves · {{second}}: {{label}}"
  },
  "leave": {
    "title": "Discard unsaved changes?",
    "body": "You have changes on this page that haven't been saved.",
    "confirm": "Discard changes",
    "cancel": "Keep editing"
  },
  "conflict": {
    "title": "Someone else changed this document",
    "body": "Your changes weren't saved. Reload to see the latest version, then make your changes again.",
    "reload": "Reload"
  },
  "creditInFull": {
    "action": "Credit in full",
    "actionMenu": "Credit in full…",
    "title": "Credit {{number}} in full?",
    "body": "A credit note dated today takes back everything not yet credited on this invoice. The invoice and its own period stay as they were.",
    "dated": "Credit note dated {{date}}",
    "loading": "Working out the credit note…",
    "linesTitle": "Coming back",
    "serials": "Serials: {{serials}}",
    "total": "Credit note total",
    "applied": "Against the open balance",
    "paidPart": "Already paid by the customer",
    "refundNow": "Refund the paid part now",
    "keptAsCredit": "The paid part stays with the customer as credit, to apply to another invoice or refund later.",
    "walkInTitle": "The paid part is refunded now",
    "walkInBody": "The walk-in customer keeps no credit, so what was paid is refunded in this step. A till sale is better returned at the till.",
    "walkInNoRight": "The walk-in customer keeps no credit, so what was paid must be refunded in this step, and you can't make refunds. Return the sale at the till, or ask someone who can.",
    "periodTitle": "Today's period is closed to postings",
    "periodBody": "Nothing dated {{date}} can be posted, so the invoice can't be credited today. Ask your accountant to open the period.",
    "confirm": "Credit in full",
    "toast": "Credit note {{number}} posted",
    "toastRefunded": "Credit note {{number}} posted, refund {{refund}} made",
    "voidHintTitle": "Voiding changes an earlier period",
    "voidHintEarlier": "This invoice is dated {{date}}. Voiding reverses it on that date, so that period's figures (VAT included) change. Credit in full posts a credit note dated today instead.",
    "voidHintLocked": "This invoice's period is locked or closed, so it can't be voided. Credit in full posts a credit note dated today instead.",
    "voidHintAction": "Credit in full instead"
  },
  "errors": {
    "PROJECT_DOCUMENT": "This document belongs to a project: void or correct it from the project.",
    "NOTHING_TO_CREDIT": "Everything on this invoice has been credited already.",
    "CREDIT_IN_FULL_AFTER_ALLOWANCE": "An allowance was given against this invoice, so returning everything would credit more than is left. Credit the rest with a return, or void the allowance first.",
    "SERIALS_UNTRACEABLE": "Some serial-tracked units can't be traced to this sale. Return them with a credit note that names their serials.",
    "WALK_IN_NO_CREDIT_FULL": "The walk-in customer keeps no credit: refund the paid part in the same step, or return the sale at the till.",
    "QUOTATION_STARTED_PROJECT": "This quotation started a project: bill it from the project.",
    "PROJECT_CUSTOMER_MISMATCH": "The project belongs to another customer: choose a project of this customer, or none.",
    "notSaved": "Not saved",
    "field": "Check this value.",
    "INSUFFICIENT_STOCK": "Not enough stock: your stock policy blocks sales that take stock below zero.",
    "INSUFFICIENT_STOCK_INVENTORY_OFF": "Not enough stock: your stock policy blocks sales that take stock below zero. Inventory is turned off for your company, so stock can't be transferred or counted: lower the quantities, or ask an administrator to change the stock policy in Settings › Inventory.",
    "INVOICE_POSTED": "Only a draft can be edited or deleted. A posted invoice can only be voided.",
    "INVOICE_NOT_POSTED": "Only a posted invoice can be voided or credited.",
    "INVOICE_HAS_CREDIT_NOTES": "Credit notes were issued against this invoice. Void them first.",
    "INVOICE_HAS_PAYMENTS": "Receipts or credit notes are applied to this invoice. Take them off it first.",
    "CUSTOMER_ARCHIVED": "This customer is archived. Restore the customer first.",
    "CUSTOMER_INACTIVE": "This customer is inactive: invoices, debit notes and quotations can't be issued to them. Reactivate the customer first, or choose another customer.",
    "ALLOCATION_EXCEEDS_BALANCE": "An amount is more than what is left to pay on its invoice.",
    "ALLOCATION_EXCEEDS_RECEIPT": "The amounts add up to more than is left on this receipt.",
    "ALLOCATION_EXCEEDS_CREDIT": "The amounts add up to more than is left on this credit note.",
    "QUOTATION_NOT_PENDING": "Only a pending quotation can be approved, rejected or deleted.",
    "QUOTATION_NOT_EDITABLE": "Only a pending or rejected quotation can be edited.",
    "QUOTATION_NOT_APPROVED": "Only an approved quotation can be converted to an invoice.",
    "QUOTATION_EXPIRED": "This quotation has expired. Confirm that you want to convert it anyway.",
    "CREDIT_NOTE_POSTED": "Only a draft credit note can be edited, posted or deleted.",
    "CREDIT_NOTE_NOT_POSTED": "Only a posted credit note can be voided or applied.",
    "CREDIT_EXCEEDS_INVOICE": "The credit is more than is left to credit on the invoice.",
    "RETURN_EXCEEDS_SOLD": "A quantity is more than can still be returned from the invoice.",
    "NO_MAIN_WAREHOUSE": "No main warehouse is set up. Ask an administrator to choose one under Inventory › Warehouses.",
    "WHOLE_UNITS_ONLY": "A product counted in whole units has a quantity with decimals.",
    "SOURCE_REFUNDED": "Part of this was refunded to the customer. Void the refund first.",
    "TILL_DOCUMENT": "This came from the till, so it can only be undone there: void the sale at the till while its shift is open.",
    "WALK_IN_NO_CREDIT": "A walk-in customer holds no credit, so this settlement can’t be removed.",
    "WALK_IN_NO_CREDIT_POST": "The walk-in customer holds no credit, so this credit note can't be posted. Take the return at the till, which refunds it at once.",
    "WALK_IN_NO_CREDIT_POST_POS_OFF": "The walk-in customer holds no credit, so this credit note can't be posted. Returns of walk-in sales are taken at the till, and Point of sale is turned off for your company: turn it back on to return this sale.",
    "SERIAL_COUNT_MISMATCH": "A serial-numbered line needs a whole quantity and one serial number per unit. Edit the draft to pick them.",
    "SERIAL_NOT_AVAILABLE": "A serial number can’t be used here: it was sold, moved or returned since. Edit the draft to pick another.",
    "SERIAL_DUPLICATE": "A serial number is listed twice, or is already in stock.",
    "SERIALS_NOT_TRACKED": "Serial numbers were given for a product that doesn’t track them.",
    "SERIAL_MOVED_ON": "A serial number on this document has moved on since (sold, returned or transferred), so it can’t be undone.",
    "STOCK_ALREADY_USED": "Some of the goods this return brought back have since been sold or moved, so it can’t be voided.",
    "RETURN_SHARE_TOO_SMALL": "Return this line in larger quantities: the amounts per unit are below one baisa.",
    "DRAFT_OUTDATED": "Something on this draft changed since it was saved (a product or tax rate). Edit the draft and save it again, then post it.",
    "CHEQUE_CLEARED": "The bank already paid the cheque of this receipt. Undo the cheque's clearing first.",
    "WAREHOUSE_ARCHIVED": "The warehouse the goods would go back to is archived. Restore it under Inventory › Warehouses before voiding this invoice.",
    "PRODUCT_ARCHIVED": "A product on this return is archived, so the goods would come back where nothing can sell or adjust them. Restore the product before taking it back.",
    "CHEQUE_NOT_CLEARED": "The cheque paid into this receipt has not cleared yet. Refund its credit once the bank pays the cheque.",
    "QUOTATION_OUTDATED": "A line of this quotation is no longer valid as quoted (a product, unit or tax rate was archived, or a pack changed size). An approved quotation can't be edited: mark it lost and edit it, or duplicate it, then approve it again before converting.",
    "ORG_UNIT_REQUIRED": "Your access covers part of the sales documents, so each one you create goes in your home unit, and you have none. Ask an administrator to set your home unit.",
    "ORG_UNIT_OUT_OF_SCOPE": "Your home unit is outside the units your sales access covers, so you couldn't see this document once saved. Ask an administrator to set your home unit or your access."
  },
  "lines": {
    "label": "Lines",
    "product": "Product",
    "productOf": "Product of line {{n}}",
    "chooseProduct": "Search product…",
    "description": "Description",
    "descriptionOf": "Description of line {{n}}",
    "descriptionPlaceholder": "Or describe the line",
    "quantity": "Qty",
    "quantityOf": "Quantity of line {{n}}",
    "price": "Unit price",
    "priceInclusive": "Price incl. VAT",
    "priceOf": "Unit price of line {{n}}",
    "discount": "Discount",
    "discountTypeOf": "Discount type of line {{n}}",
    "discountType": {
      "PERCENTAGE": "Percentage",
      "PER_UNIT": "Amount per unit",
      "LINE_AMOUNT": "Amount off the line"
    },
    "perUnitValue": "{{amount}} per unit",
    "perLineValue": "{{amount}} per line",
    "tax": "VAT",
    "taxOf": "VAT rate of line {{n}}",
    "noTax": "No VAT",
    "lineTotal": "Line total",
    "returned": "Returned",
    "add": "Add line",
    "remove": "Remove line {{n}}",
    "actions": "Line actions",
    "totalsLabel": "Total",
    "enterHint": "Enter on the last line adds a new one. Scan a barcode into the product field to add it.",
    "wholeUnits": "This product is counted in whole units.",
    "productAndDescription": "Product / description",
    "addDescription": "Add description",
    "lineN": "on line {{n}}",
    "noTaxShort": "No VAT",
    "enterHintText": "Enter on the last line adds a new one.",
    "taxable": "Taxable",
    "discountOfTyped": "Discount of line {{n}}, {{type}}",
    "discountShort": {
      "PERCENTAGE": "%",
      "PER_UNIT": "/unit",
      "LINE_AMOUNT": "/line"
    },
    "discountAs": {
      "PERCENTAGE": "percentage",
      "PER_UNIT": "amount per unit",
      "LINE_AMOUNT": "amount off the line"
    },
    "sold": "Sold",
    "soldOf": "Sold {{quantity}}",
    "stillReturnable": "{{quantity}} still returnable",
    "serials": {
      "short": "Pick one serial number per unit: {{picked}} of {{quantity}} picked.",
      "wholeUnits": "Serial-numbered products are counted in whole units, one serial number each.",
      "notSold": "Not sold on this invoice line, or already returned: {{serials}}",
      "codes": {
        "SERIAL_COUNT_MISMATCH": "The serial numbers don’t match the quantity: {{serials}}",
        "SERIAL_NOT_AVAILABLE": "Not in stock at this warehouse: {{serials}}",
        "SERIAL_DUPLICATE": "Listed twice, or already in stock: {{serials}}",
        "SERIALS_NOT_TRACKED": "This product doesn’t track serial numbers: {{serials}}",
        "SERIAL_MOVED_ON": "Moved on since: {{serials}}"
      }
    }
  },
  "totals": {
    "gross": "Amount before discount",
    "discount": "Discount",
    "subtotal": "Taxable amount",
    "tax": "VAT",
    "taxAt": "VAT at {{rate}}",
    "total": "Total",
    "paid": "Paid",
    "balance": "Balance due",
    "inclusiveNote": "Prices include VAT. Amounts before discount and discounts are shown without VAT.",
    "exclusiveNote": "Prices exclude VAT.",
    "inclusiveShort": "Prices include VAT",
    "exclusiveShort": "Prices exclude VAT",
    "credited": "Credited",
    "title": "Totals"
  },
  "allocations": {
    "date": "Applied on",
    "amount": "Amount",
    "total": "Total applied",
    "source": "Paid by",
    "number": "Document",
    "receipt": "Receipt",
    "creditNote": "Credit note"
  },
  "void": {
    "reason": "Reason",
    "reasonWas": "Reason: {{reason}}"
  },
  "print": {
    "companySlot": "The company address and VAT number appear here once the company profile is filled in (Administration › Settings).",
    "taxInvoice": "Tax invoice",
    "debitNote": "Debit note",
    "creditNote": "Credit note",
    "quotation": "Quotation",
    "back": "Back",
    "billTo": "Bill to",
    "customerCode": "Customer code",
    "customerVat": "VAT number",
    "phone": "Phone",
    "email": "Email",
    "footer": "Amounts in Omani rials (<rial/>).",
    "vatNumber": "VAT No.",
    "crNumber": "CR No.",
    "creditTo": "Credited to",
    "preparedFor": "Prepared for",
    "quotationFooter": "Amounts in Omani rials (<rial/>). Valid until {{date}}.",
    "voidBanner": "Voided — not payable",
    "voidBody": "This invoice was cancelled. Nothing is owed on it.",
    "owedSummary": "Balance due {{amount}} · due {{date}}",
    "signature": "Authorised signature",
    "companyStamp": "Company stamp",
    "receivedByCustomer": "Received by (customer)",
    "signatureBlock": "Signature and company stamp",
    "terms": "Terms and conditions",
    "paymentDetails": "Payment details",
    "accountNo": "Account",
    "iban": "IBAN"
  },
  "invoices": {
    "title": "Invoices",
    "new": "New invoice",
    "newDebitNote": "New debit note",
    "newTitle": "New invoice",
    "newSubtitle": "Saved as a draft. The number is assigned when you post it.",
    "newDebitNoteTitle": "New debit note",
    "newDebitNoteSubtitle": "An extra charge to a customer for services or amounts. Saved as a draft.",
    "editTitle": "Edit {{title}}",
    "editSubtitle": "Edit draft",
    "draftInvoice": "Draft invoice",
    "draftDebitNote": "Draft debit note",
    "saveDraft": "Save draft",
    "notDraftTitle": "This invoice is no longer a draft",
    "backToInvoice": "Back to invoice",
    "voidTitle": "This invoice is void",
    "mainWarehouse": "Main warehouse",
    "mainWarehouseNamed": "Main warehouse ({{code}})",
    "searchLabel": "Search invoices",
    "searchPlaceholder": "Number, customer, reference…",
    "kindFilter": "Filter by type",
    "allKinds": "All types",
    "views": {
      "label": "Invoice views",
      "all": "All",
      "open": "Open",
      "void": "Void",
      "drafts": "Drafts",
      "overdue": "Overdue",
      "paid": "Paid",
      "owed": "owed"
    },
    "empty": {
      "all": "No invoices yet.",
      "body": "Create an invoice for a customer, or convert an approved quotation.",
      "open": "Nothing is waiting to be paid.",
      "void": "No void invoices.",
      "drafts": "No draft invoices.",
      "mine": "You have no drafts waiting.",
      "overdue": "Nothing is overdue.",
      "paid": "No paid invoices in this view."
    },
    "sections": {
      "invoice": "Invoice",
      "debitNote": "Debit note",
      "settlements": "Settlements",
      "creditNotes": "Credit notes issued against it",
      "document": "Lines and totals",
      "details": "Details",
      "customerAndDates": "Customer and dates"
    },
    "fields": {
      "invoiceDate": "Invoice date",
      "dueDate": "Due date",
      "warehouse": "Warehouse",
      "taxMode": "Tax",
      "createdBy": "Created by"
    },
    "hints": {
      "dueDate": "{{days}} days after the invoice date unless you choose another date.",
      "warehouse": "Goods are issued from here when the invoice is posted.",
      "reference": "The customer's order number or your own.",
      "lines": "Search a product by name, SKU or barcode, or describe a line yourself.",
      "debitNoteLines": "A debit note charges services or amounts; goods are invoiced.",
      "notes": "Printed on the invoice.",
      "termDays_one": "{{count}} day",
      "termDays_other": "{{count}} days",
      "linesText": "Describe each line: what was sold, its quantity and price."
    },
    "actions": {
      "post": "Post",
      "void": "Void invoice",
      "delete": "Delete draft",
      "open": "Open",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "reissue": "Re-issue as a new draft",
      "recordReceipt": "Record receipt",
      "print": "Print",
      "share": "Share",
      "creditNote": "Credit note",
      "applyCredit": "Apply credit",
      "viewSettlements": "View settlements",
      "postMenu": "Post…",
      "deleteMenu": "Delete draft…",
      "shareMenu": "Share…",
      "voidMenu": "Void invoice…"
    },
    "post": {
      "body": "Total {{total}}. Posting gives it a number, issues the goods from stock and records the sale in the books. It can't be edited afterwards, only voided.",
      "bodyDebitNote": "Total {{total}}. Posting gives it a number and records the charge in the books. It can't be edited afterwards, only voided.",
      "confirmAnyway": "Post anyway",
      "titleInvoice": "Post the invoice for {{customer}}?",
      "titleDebitNote": "Post the debit note for {{customer}}?",
      "dates": "Dated {{date}} · due {{due}}",
      "stale_one": "This invoice is dated {{count}} day ago. Posting uses that date.",
      "stale_other": "This invoice is dated {{count}} days ago. Posting uses that date.",
      "staleDebitNote_one": "This debit note is dated {{count}} day ago. Posting uses that date.",
      "staleDebitNote_other": "This debit note is dated {{count}} days ago. Posting uses that date.",
      "changeDate": "Change date"
    },
    "delete": {
      "title": "Delete this draft?",
      "body": "The draft is removed. A draft converted from a quotation hands the quotation back so it can be converted again."
    },
    "void": {
      "title": "Void {{number}}?",
      "body": "Its journal entry is reversed and the goods go back into stock. The invoice stays on record, marked void.",
      "removeFirst_one": "Remove the {{count}} settlement first.",
      "removeFirst_other": "Remove the {{count}} settlements first.",
      "creditFirst_one": "Void credit note {{number}} first.",
      "creditFirst_other": "Void the {{count}} credit notes issued against it first.",
      "removeOne": "Remove {{number}} from this invoice first.",
      "checkingCredits": "Checking credit notes…",
      "creditsFailed": "Credit notes couldn’t be loaded. Reload the page to void."
    },
    "toast": {
      "saved": "Draft saved",
      "posted": "Invoice {{number}} posted",
      "deleted": "Draft deleted",
      "voided": "{{number}} voided",
      "postedDebitNote": "Debit note {{number}} posted",
      "exported_one": "Exported {{n}} invoice",
      "exported_other": "Exported {{n}} invoices",
      "exportedView": "Exported the invoices in this view",
      "savedDraft": "Saved as a draft"
    },
    "export": "Export view",
    "exportHint_one": "CSV of the {{n}} invoice in this view",
    "exportHint_other": "CSV of the {{n}} invoices in this view",
    "rowActions": "Actions for {{number}}",
    "mine": "Mine",
    "refShort": "Ref",
    "voidedOn": "Voided {{date}}",
    "printedNotes": "Notes (printed)",
    "createdBySystem": "Imported or by the system",
    "moreDetails": "More details",
    "hasNotes": "notes",
    "saveAndPost": "Save and post",
    "copyTitle": "New invoice (copy of {{number}})",
    "copyDebitNoteTitle": "New debit note (copy of {{number}})",
    "copyFailed": "The invoice to copy couldn’t be loaded. Start from this blank draft, or go back and try again.",
    "form": {
      "shortcuts": "{{save}} saves the draft · {{post}} saves and posts",
      "footerTotal_one": "{{count}} line · Total {{total}}",
      "footerTotal_other": "{{count}} lines · Total {{total}}"
    },
    "list": {
      "daysOverdue_one": "{{count}} d overdue",
      "daysOverdue_other": "{{count}} d overdue",
      "daysLate_one": "{{count}} d",
      "daysLate_other": "{{count}} d",
      "daysOverdueSpoken_one": "{{count}} day overdue",
      "daysOverdueSpoken_other": "{{count}} days overdue"
    },
    "figures": {
      "label": "Invoice figures",
      "vat": "VAT {{amount}}",
      "overdue_one": "{{count}} day overdue",
      "overdue_other": "{{count}} days overdue",
      "dueToday": "Due today",
      "dueIn_one": "Due in {{count}} day",
      "dueIn_other": "Due in {{count}} days",
      "nothingPaid": "Nothing paid yet",
      "nothingOwed": "Nothing owed",
      "settled": "Settled",
      "received": "{{amount}} received",
      "credited": "{{amount}} credited",
      "datedAgo_one": "{{count}} day ago",
      "datedAgo_other": "{{count}} days ago",
      "datedToday": "Today",
      "paidInFull": "Paid in full · {{date}}"
    },
    "settlements": {
      "none": "No receipts yet.",
      "recordOne": "Record a receipt.",
      "void": "Void: nothing is owed.",
      "removed": "{{number}} removed from {{invoice}}",
      "removeTitle": "Remove {{number}} from this invoice?",
      "removeBody": "{{amount}} goes back to the customer’s unapplied credit, and the invoice is open again for it.",
      "remove": "Remove",
      "removeNamed": "Remove {{number}} from this invoice",
      "creditNotice": "{{customer}} has {{amount}} unapplied credit.",
      "applyIt": "Apply it",
      "creditsFailed": "Credit notes couldn’t be loaded."
    },
    "stock": {
      "checking": "Checking stock…",
      "failed": "Stock couldn’t be checked. You can still post.",
      "title_one": "{{count}} line is short of stock at {{warehouse}}",
      "title_other": "{{count}} lines are short of stock at {{warehouse}}",
      "line": "needs {{required}}, on hand {{onHand}}",
      "hint": "You can still post: stock goes below zero until the goods are received.",
      "blockedTitle_one": "Not enough stock to post: {{count}} line is short at {{warehouse}}",
      "blockedTitle_other": "Not enough stock to post: {{count}} lines are short at {{warehouse}}",
      "blockedHint": "Your stock policy blocks sales that take stock below zero. Receive or transfer the goods, or lower the quantities, then post again.",
      "blockedHintInventoryOff": "Your stock policy blocks sales that take stock below zero. Inventory is turned off for your company, so stock can't be transferred or counted: lower the quantities, or ask an administrator to change the stock policy in Settings › Inventory."
    },
    "errors": {
      "chooseCustomer": "Choose a customer"
    },
    "editDraftTitle": "Edit draft invoice",
    "editDraftDebitNoteTitle": "Edit draft debit note",
    "stampStatus": "Status:",
    "stampPayment": "Payment:",
    "stats": {
      "label": "Invoice figures",
      "open": "Open",
      "overdue": "Overdue",
      "netSales": "Net sales",
      "netSalesDetail": "{{month}} · {{invoices}}",
      "drafts": "Drafts",
      "draftsDetail": "Waiting to be posted",
      "overdueShare": "{{percent}}% of the open balance is overdue",
      "trend": "Net sales by month, {{from}} to {{to}}",
      "unavailable": "Figures unavailable",
      "invoices_one": "{{n}} invoice",
      "invoices_other": "{{n}} invoices"
    }
  },
  "quotations": {
    "status": {
      "PENDING": "Pending",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "CONVERTED": "Converted",
      "EXPIRED": "Expired",
      "EXPIRES_SOON": "Expires soon"
    },
    "title": "Quotations",
    "subtitle": "Price offers to customers. Approved quotations convert to draft invoices.",
    "new": "New quotation",
    "newTitle": "New quotation",
    "newSubtitle": "The number is assigned when you save. Nothing is posted or taken from stock.",
    "editTitle": "Edit {{number}}",
    "editSubtitle": "Edit quotation",
    "save": "Save quotation",
    "kind": "Quotation",
    "notEditableTitle": "This quotation can no longer be edited",
    "backToQuotation": "Back to quotation",
    "editRejected": "This quotation was rejected. Saving your changes makes it pending again.",
    "expiredTitle": "This quotation has expired",
    "expiredBody": "It was valid until {{date}}. It can still be converted, with a confirmation.",
    "rejectedTitle": "This quotation was rejected",
    "approvedOn": "Approved {{at}}",
    "rejectedOn": "Rejected {{at}}",
    "searchLabel": "Search quotations",
    "searchPlaceholder": "Search number or customer…",
    "sections": {
      "quotation": "Quotation",
      "summary": "Summary"
    },
    "fields": {
      "quotationDate": "Quotation date",
      "validUntil": "Valid until",
      "decided": "Decision",
      "converted": "Converted",
      "approved": "Approved",
      "rejected": "Rejected",
      "lost": "Marked lost",
      "invoice": "Invoice"
    },
    "hints": {
      "validUntil": "{{days}} days after the quotation date unless you choose another date.",
      "notes": "Printed on the quotation."
    },
    "views": {
      "label": "Quotation views",
      "all": "All",
      "pending": "Pending",
      "approved": "Approved",
      "expired": "Expired",
      "converted": "Converted",
      "rejected": "Rejected or lost",
      "value": "Open value"
    },
    "stats": {
      "label": "Quotation figures",
      "pending": "Pending",
      "pendingDetail": "{{quotations}} awaiting a decision",
      "approved": "Approved",
      "approvedDetail": "{{quotations}} to convert",
      "conversion": "Converted",
      "percent": "{{percent}}%",
      "none": "—",
      "conversionDetail": "{{converted}} of {{decided}} decided",
      "conversionEmpty": "None decided yet",
      "conversionShare": "{{percent}}% of the decided quotations were converted",
      "expired": "Expired",
      "expiredDetail": "Past their valid-until date, still open",
      "quotations_one": "{{n}} quotation",
      "quotations_other": "{{n}} quotations"
    },
    "empty": {
      "all": "No quotations yet.",
      "body": "Send a customer a price offer; once approved it becomes a draft invoice in one step.",
      "pending": "No quotations are waiting for a decision.",
      "approved": "No approved quotations to convert.",
      "expired": "No open quotations have expired.",
      "converted": "No quotations have been converted yet.",
      "rejected": "No rejected or lost quotations."
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "convert": "Convert to invoice",
      "viewInvoice": "View invoice",
      "delete": "Delete quotation",
      "approveConvert": "Approve and convert",
      "edit": "Edit",
      "rejectMenu": "Reject…",
      "markLost": "Mark lost",
      "markLostMenu": "Mark lost…",
      "shareMenu": "Share…"
    },
    "approve": {
      "title": "Approve {{number}}?",
      "body": "An approved quotation can be converted to an invoice. It can no longer be edited."
    },
    "delete": {
      "title": "Delete {{number}}?",
      "body": "The quotation is removed. Its number is not reused."
    },
    "reject": {
      "title": "Reject {{number}}?",
      "body": "A rejected quotation can be edited, which makes it pending again.",
      "reason": "Reason",
      "reasonHint": "Optional. Shown on the quotation."
    },
    "convert": {
      "title": "Convert {{number}} to an invoice",
      "body": "A draft invoice is created from the quotation's lines, priced the same way. Review it, then post it.",
      "confirm": "Create draft invoice",
      "expiredTitle": "This quotation has expired",
      "expiredBody": "It was valid until {{date}}. Prices may have changed since.",
      "confirmExpired": "Convert it anyway",
      "approveTitle": "Approve {{number}} and convert it",
      "approveBody": "The quotation is approved, then a draft invoice is made from its lines, priced the same way. Review it, then post it.",
      "approveConfirm": "Approve and create draft invoice",
      "approvedOnly": "Approved, not converted"
    },
    "toast": {
      "created": "Quotation {{number}} created",
      "saved": "Quotation saved",
      "approved": "{{number}} approved",
      "rejected": "{{number}} rejected",
      "deleted": "{{number}} deleted",
      "converted": "{{number}} converted to a draft invoice",
      "savedApproved": "{{number}} saved and approved",
      "savedNotApproved": "{{number}} saved, not approved: {{reason}}",
      "lost": "{{number}} marked lost"
    },
    "copyTitle": "Copy of {{number}}",
    "copyFailed": "The quotation to copy couldn’t be loaded. This is a blank quotation.",
    "copyTaxMode": {
      "title": "Check the copied prices",
      "nowExclusive": "{{number}} was priced with VAT included. New quotations are priced before VAT, so the copied prices are now read before VAT and the total rises by the VAT.",
      "nowInclusive": "{{number}} was priced before VAT. New quotations are priced with VAT included, so the copied prices now include the VAT and the total falls by it."
    },
    "changedMeanwhile": "{{number}} was edited since you opened it. Its latest version is shown now: check it, then try again.",
    "lost": {
      "title": "Mark {{number}} lost?",
      "body": "The customer declined the offer, or it was superseded. It is closed as rejected, with the reason. To offer again, duplicate it.",
      "reasonHint": "Why the offer was lost. Kept with the quotation.",
      "reasonRequired": "Say why the offer was lost"
    },
    "lostTitle": "This offer was lost",
    "saveAndApprove": "Save and approve",
    "validity": {
      "validFor_zero": "Last day today",
      "validFor_one": "Valid for 1 more day",
      "validFor_other": "Valid for {{count}} more days",
      "left_zero": "Last day",
      "left_one": "{{count}} day left",
      "left_other": "{{count}} days left",
      "expiredAgo_one": "Expired yesterday",
      "expiredAgo_other": "Expired {{count}} days ago"
    }
  },
  "creditNotes": {
    "draftTitle": "Draft credit note",
    "kind": {
      "RETURN": "Return",
      "ALLOWANCE": "Allowance"
    },
    "title": "Credit notes",
    "subtitle": "Returns and allowances that reduce what customers owe.",
    "new": "New credit note",
    "newTitle": "New credit note",
    "newSubtitle": "Saved as a draft. The number is assigned when you post it.",
    "editTitle": "Edit {{title}}",
    "editSubtitle": "Edit draft",
    "saveDraft": "Save draft",
    "notDraftTitle": "This credit note is no longer a draft",
    "backToNote": "Back to credit note",
    "voidTitle": "This credit note is void",
    "draftNote": "This is a draft: it isn't in the books yet. Post it to credit the customer.",
    "creditTitle": "Unapplied credit: {{amount}}",
    "creditBody": "It is on the customer's account as credit. Apply it to their open invoices.",
    "applied": "Applied",
    "noAllocations": "This credit note isn't applied to any invoice.",
    "unallocateBody": "The invoice is open again for that amount, and it goes back to the customer's credit.",
    "remainder": "{{amount}} stays on the customer's account as credit.",
    "searchLabel": "Search credit notes",
    "searchPlaceholder": "Search number, reason or customer…",
    "kindFilter": "Filter by type",
    "allKinds": "Returns and allowances",
    "invoiceWarehouse": "The invoice's warehouse",
    "invoiceWarehouseNamed": "The invoice's warehouse ({{code}})",
    "chooseInvoice": "Choose an invoice",
    "chooseCustomerFirst": "Choose the customer first",
    "searchInvoices": "Search invoice number…",
    "noInvoices": "No posted invoices for this customer.",
    "noInvoice": "Not against an invoice",
    "pickInvoice": "Choose the invoice the goods came from.",
    "pickInvoiceBody": "Its lines appear here with what can still be returned of each.",
    "returnAll": "Return everything left",
    "sold": "Sold",
    "returnable": "Can return",
    "returnQuantity": "Return",
    "returnQuantityOf": "Quantity to return of {{description}}",
    "credited": "Credit",
    "totalCredit": "Total credit",
    "kindHint": {
      "RETURN": "Goods or services coming back from an invoice. Prices, discounts and tax come from the invoice.",
      "ALLOWANCE": "A price reduction or goodwill amount, with or without an invoice. No stock moves."
    },
    "sections": {
      "note": "Credit note",
      "returnLines": "Lines returned",
      "allocations": "Invoices settled"
    },
    "fields": {
      "kind": "Type",
      "invoice": "Invoice",
      "date": "Date",
      "warehouse": "Return to warehouse",
      "reason": "Reason"
    },
    "hints": {
      "returnInvoice": "Only posted invoices can be credited.",
      "allowanceInvoice": "Optional. When chosen, the credit follows its tax mode and is applied to it on posting.",
      "warehouse": "Where the returned goods go back into stock.",
      "reason": "Printed on the credit note.",
      "returnLines": "Enter the quantity coming back for each line, up to what can still be returned.",
      "allowanceLines": "Describe what is credited, with its tax."
    },
    "errors": {
      "returnLimit": "A quantity is more than can still be returned. Correct the highlighted lines.",
      "noReturnLines": "Enter a quantity to return on at least one line.",
      "lineLimit": "Only {{quantity}} can still be returned."
    },
    "actions": {
      "post": "Post",
      "apply": "Apply to invoices",
      "delete": "Delete draft",
      "void": "Void credit note",
      "edit": "Edit",
      "postMenu": "Post…"
    },
    "post": {
      "title": "Post this credit note to {{customer}}?",
      "body": "Total {{total}}. Posting gives it a number and records it in the books; returned goods go back into stock.",
      "unapplied": "The credit stays on the customer's account, unapplied, until you apply or refund it.",
      "appliesAll": "{{total}} is applied to {{invoice}}.",
      "appliesPart": "{{applied}} is applied to {{invoice}}; {{rest}} stays as {{customer}}'s unapplied credit.",
      "appliesNone": "{{invoice}} is already paid, so {{total}} stays as {{customer}}'s unapplied credit. Refund it or apply it later.",
      "appliesUnknown": "It is applied to what {{invoice}} still owes; anything left stays as {{customer}}'s unapplied credit.",
      "date": "{{kind}} dated {{date}}, in Omani rials.",
      "stale_one": "It is dated {{count}} day ago. Check the date before posting.",
      "stale_other": "It is dated {{count}} days ago. Check the date before posting."
    },
    "delete": {
      "title": "Delete this draft?",
      "body": "The draft credit note is removed."
    },
    "apply": {
      "title": "Apply {{number}}",
      "body": "Unapplied credit on this credit note: {{amount}}."
    },
    "void": {
      "title": "Void {{number}}?",
      "body": "The amounts applied to invoices are released and its journal entry is reversed. The credit note stays on record, marked void.",
      "bodyReturn": "The amounts applied to invoices are released, its journal entry is reversed and the returned goods leave stock again. The credit note stays on record, marked void."
    },
    "toast": {
      "saved": "Draft saved",
      "posted": "Credit note posted",
      "deleted": "Draft deleted",
      "applied": "Applied to invoices",
      "voided": "{{number}} voided",
      "savedDraft": "Credit note saved as a draft",
      "view": "View credit note",
      "postedNumber": "Credit note {{number}} posted"
    },
    "empty": {
      "title": "No credit notes yet.",
      "body": "Credit a return or a price reduction from an invoice, or here.",
      "drafts": "No draft credit notes.",
      "withCredit": "No credit notes with unapplied credit.",
      "void": "No void credit notes."
    },
    "choice": {
      "RETURN": "Return goods",
      "ALLOWANCE": "Allowance"
    },
    "saveAndPost": "Save and post",
    "views": {
      "label": "Credit note views",
      "all": "All",
      "drafts": "Drafts",
      "withCredit": "With unapplied credit",
      "void": "Void"
    },
    "stats": {
      "label": "Credit note figures",
      "unapplied": "Unapplied credit",
      "unappliedDetail": "{{notes}} to apply or refund",
      "drafts": "Drafts",
      "draftsDetail": "Waiting to be posted",
      "credited": "Credited ex VAT",
      "creditedDetail": "{{month}} · {{notes}}",
      "creditedAll": "{{month}} · all customers",
      "trend": "Credited ex VAT by month, {{from}} to {{to}}",
      "unavailable": "Figures unavailable",
      "void": "Void",
      "voidDetail": "Cancelled, no effect on balances",
      "notes_one": "{{n}} credit note",
      "notes_other": "{{n}} credit notes"
    }
  },
  "method": {
    "CASH": "Cash",
    "CARD": "Card",
    "BANK_TRANSFER": "Bank transfer",
    "CHEQUE": "Cheque",
    "OTHER": "Other"
  },
  "allocate": {
    "fillOldest": "Fill oldest first",
    "clear": "Clear amounts",
    "limited": "Showing the {{n}} oldest open invoices.",
    "noOpen": "This customer has no open invoices.",
    "noOpenBody": "The whole amount stays on the customer's account as credit, to apply later.",
    "tableLabel": "Open invoices",
    "apply": "Apply",
    "applyTo": "Amount to apply to {{number}}",
    "overBalance": "More than is left to pay on this invoice.",
    "available": "To apply",
    "allocated": "Applied",
    "unallocated": "Unapplied",
    "exceeds": "The amounts are {{amount}} more than is available. Lower them.",
    "exceedsReceipt": "The amounts applied add up to more than the receipt. Lower them or raise the amount.",
    "confirm": "Apply",
    "refunded": "Refunded"
  },
  "receipts": {
    "title": "Receipts",
    "subtitle": "Money received from customers and the invoices it settles.",
    "new": "Record receipt",
    "newTitle": "Record a receipt",
    "newSubtitle": "Posted to the books straight away. The number is assigned when you save.",
    "kind": "Receipt",
    "save": "Record receipt",
    "searchLabel": "Search receipts",
    "searchPlaceholder": "Search number, reference or customer…",
    "chooseAccount": "Choose the cash or bank account",
    "chooseCustomerFirst": "Choose the customer to see their open invoices.",
    "remainder": "{{amount}} stays on the customer's account as credit, to apply to later invoices.",
    "creditTitle": "Unapplied credit: {{amount}}",
    "creditBody": "It is on the customer's account as credit. Apply it to invoices when they are issued.",
    "voidTitle": "This receipt is void",
    "noAllocations": "This receipt isn't applied to any invoice.",
    "noAllocationsHint": "Apply it to the customer's open invoices.",
    "sections": {
      "receipt": "Receipt",
      "allocation": "Apply to invoices",
      "allocations": "Invoices settled",
      "payment": "Payment"
    },
    "fields": {
      "date": "Receipt date",
      "amount": "Amount received",
      "account": "Received into",
      "method": "Method",
      "invoice": "Invoice",
      "recordedAt": "Recorded"
    },
    "hints": {
      "noAccounts": "No active cash or bank account. Ask an administrator to add one under Accounting › Cash & bank.",
      "reference": "Cheque or transfer number.",
      "allocation": "Apply the money to the customer's open invoices, oldest first or amount by amount."
    },
    "actions": {
      "allocate": "Apply to invoices",
      "void": "Void receipt",
      "unallocate": "Remove",
      "unallocateNamed": "Remove the amount applied to {{number}}",
      "label": "Actions"
    },
    "allocate": {
      "title": "Apply {{number}}",
      "body": "Unapplied credit on this receipt: {{amount}}."
    },
    "unallocate": {
      "title": "Remove the amount applied to {{number}}?",
      "body": "{{invoice}} is open again for {{amount}}, and {{amount}} becomes {{customer}}'s unapplied credit."
    },
    "void": {
      "title": "Void {{number}}?",
      "body": "{{amount}} comes off {{customer}}'s credit and out of {{account}}, and its journal entry is reversed. The receipt stays on record, marked void.",
      "bodyApplied": "{{amount}} comes out of {{account}} and its journal entry is reversed. The receipt stays on record, marked void.",
      "reopens_one": "{{invoices}} is owed again for what this receipt paid.",
      "reopens_other": "{{count}} invoices are owed again for what this receipt paid: {{invoices}}."
    },
    "toast": {
      "created": "Receipt {{number}} recorded",
      "allocated": "Applied to invoices",
      "unallocated": "Removed from {{number}}",
      "voided": "{{number}} voided",
      "view": "View receipt"
    },
    "empty": {
      "title": "No receipts yet.",
      "body": "Record money received from a customer.",
      "withCredit": "No receipts with unapplied credit.",
      "void": "No void receipts."
    },
    "views": {
      "label": "Receipt views",
      "all": "All",
      "withCredit": "With unapplied credit",
      "void": "Void",
      "unapplied": "Unapplied",
      "received": "Received"
    },
    "stats": {
      "label": "Receipt figures",
      "received": "Received",
      "unapplied": "Unapplied credit",
      "unappliedDetail": "{{receipts}} to apply or refund",
      "unappliedShare": "{{percent}}% of what was received is not yet applied",
      "void": "Void",
      "voidDetail": "Cancelled, nothing received",
      "receipts_one": "{{n}} receipt",
      "receipts_other": "{{n}} receipts"
    }
  },
  "statement": {
    "title": "Customer statement",
    "printedAt": "Printed {{at}}",
    "invalidRange": "Choose a start date before the end date.",
    "document": "Document",
    "debit": "Debit",
    "credit": "Credit",
    "balance": "Balance",
    "opening": "Opening balance",
    "closing": "Closing balance",
    "empty": "No transactions in this period.",
    "hint": "From the books: invoices, debit notes and refunds are debits; receipts and credit notes are credits. A negative balance is the customer's credit.",
    "source": {
      "SalesInvoice": "Invoice",
      "Receipt": "Receipt",
      "CreditNote": "Credit note",
      "journal": "Journal entry",
      "CustomerRefund": "Refund"
    },
    "totals": "Totals for the period",
    "amountDue": "amount due",
    "inCredit": "in credit",
    "reversal": "Reversal: the document was voided",
    "kind": {
      "INVOICE": "Invoice",
      "DEBIT_NOTE": "Debit note",
      "RECEIPT": "Receipt",
      "CREDIT_NOTE": "Credit note",
      "REFUND": "Refund",
      "OTHER": "Other posting"
    },
    "postings_one": "{{count}} posting",
    "postings_other": "{{count}} postings"
  },
  "aging": {
    "title": "Receivables aging",
    "subtitle": "What each customer owes, by how long it is past due, less receipts and credits not yet applied.",
    "asOf": "As of {{date}}",
    "asOfLabel": "As of",
    "printedAt": "Printed {{at}}",
    "searchLabel": "Filter customers",
    "searchPlaceholder": "Filter by customer…",
    "bucket": {
      "current": "Not yet due",
      "days1to30": "1–30 days",
      "days31to60": "31–60 days",
      "days61to90": "61–90 days",
      "over90": "Over 90 days"
    },
    "credit": "Unapplied credit",
    "total": "Balance",
    "totals": "Total",
    "empty": "No customer owes anything on this date.",
    "emptyBody": "Posted invoices with an open balance appear here.",
    "hint": "Days past due are counted from each invoice's due date. Amounts applied later than the date don't count yet.",
    "summary": {
      "title": "Balance due by age",
      "owed": "Owed by customers",
      "customers_one": "{{count}} customer with a balance",
      "customers_other": "{{count}} customers with a balance",
      "overdue": "Overdue",
      "share": "{{share}} of the balance",
      "creditNote": "Taken off the balance",
      "bar": "Aging of the balance due",
      "narrowed": "Customers with a balance in “{{column}}”",
      "showAll": "Show all"
    }
  },
  "tillDocument": {
    "title": "Made at the till",
    "invoice": "This invoice was issued for a till sale, so it can't be voided here. To undo it, void the sale at the till while its shift is open.",
    "invoicePosOff": "This invoice was issued for a till sale, so it can't be voided here. Point of sale is turned off for your company: the sale can be voided at the till once it is turned back on.",
    "receipt": "This receipt is the payment of a till sale, so it can't be voided here. To undo it, void the sale at the till while its shift is open.",
    "receiptPosOff": "This receipt is the payment of a till sale, so it can't be voided here. Point of sale is turned off for your company: the sale can be voided at the till once it is turned back on.",
    "creditNote": "This credit note records goods returned at the till, so it can't be voided here.",
    "returnTitle": "Returns go through the till",
    "returnPosOn": "This sale went to the walk-in customer and is paid. The walk-in customer holds no credit, so a credit note can't be posted for it: goods coming back are returned and refunded at the till.",
    "openTill": "Open the till",
    "returnPosOff": "This sale went to the walk-in customer and is paid. The walk-in customer holds no credit, so goods coming back are returned and refunded at the till. Point of sale is turned off for your company: turn it back on to return this sale."
  },
  "project": {
    "field": "Project",
    "hint": "A project of this customer whose revenue this is.",
    "chooseCustomerFirst": "Choose the customer first.",
    "none": "No project",
    "placeholder": "Choose a project",
    "allowanceHint": "Without an invoice: a project of this customer. With an invoice, the note takes the invoice's project.",
    "quotationHint": "Extra work for a running project: the invoice it converts into carries the project.",
    "fromInvoice": "Project (from the invoice)",
    "issuedBy": "Issued by project {{code}}: it is voided from the project.",
    "contractClaim": "Contract invoice: claim {{claim}} of {{code}}.",
    "contractClaimPlain": "Contract invoice: a progress claim of {{code}}.",
    "contractAdvance": "Contract invoice: the advance payment of {{code}}.",
    "contractRetention": "Contract invoice: a retention release of {{code}}.",
    "glRole": {
      "contract_revenue": "Claim",
      "customer_advances": "Advance",
      "retention_receivable": "Retention"
    },
    "glRoleHint": {
      "contract_revenue": "A certified progress claim (contract revenue)",
      "customer_advances": "An advance payment invoice (customer advances)",
      "retention_receivable": "A retention release (retention receivable)"
    },
    "voidFromProject": "Void from the project",
    "voidThere": "Ask someone who can open the project to void it from its Billing tab.",
    "start": "Start project",
    "openStarted": "Open project {{code}}",
    "readyHint_one": "{{code}} has 1 item ready to invoice ({{total}}). Invoice it from the project's Billing tab so it's marked invoiced.",
    "readyHint_other": "{{code}} has {{count}} items ready to invoice ({{total}}). Invoice them from the project's Billing tab so they're marked invoiced.",
    "openBilling": "Open {{code}} Billing",
    "startedTitle": "This quotation started project {{code}}",
    "startedBody": "It is billed from the project's billing plan, so it can no longer be converted to an invoice.",
    "correctThrough": {
      "contract_revenue": "Corrections go through the project: void the latest claim or adjust the next one.",
      "customer_advances": "Corrections go through the project: void the advance there while no certificate has recovered it.",
      "retention_receivable": "Corrections go through the project: void the release there."
    }
  },
  "trail": {
    "project": "Project",
    "projectSlip": "Project {{code}}, {{name}}",
    "label": "Document trail",
    "quotation": "Quotation",
    "tillSale": "Till sale",
    "tillCompleted": "Completed",
    "tillVoid": "Void",
    "receipt": "Receipt",
    "creditNote": "Credit note",
    "journal": "Journal entry",
    "settlements_one": "Receipts and credit notes, {{count}} document",
    "settlements_other": "Receipts and credit notes, {{count}} documents",
    "more_one": "+{{count}} more",
    "more_other": "+{{count}} more",
    "slip": "{{kind}} {{number}}, {{amount}}, {{status}}",
    "slipCurrent": "{{kind}} {{number}} (this document), {{amount}}, {{status}}",
    "notApplied": "Not applied",
    "slipNotApplied": "{{kind}} {{number}}, {{amount}}, {{status}}, not applied to this invoice",
    "reversedShort": "reversed",
    "journalSpoken": "Journal entry {{number}}",
    "journalReversedSpoken": "Journal entry {{number}}, reversed",
    "failed": "Some related documents couldn’t be loaded.",
    "retry": "Retry",
    "invoice": "Invoice",
    "refund": "Refund",
    "invoices_one": "Invoices settled, {{count}} document",
    "invoices_other": "Invoices settled, {{count}} documents",
    "refunds_one": "Refunds, {{count}} document",
    "refunds_other": "Refunds, {{count}} documents",
    "sources_one": "Credit refunded, {{count}} document",
    "sources_other": "Credit refunded, {{count}} documents",
    "settles_one": "Invoices settled and refunds, {{count}} document",
    "settles_other": "Invoices settled and refunds, {{count}} documents",
    "slipApplied": "{{kind}} {{number}}, {{amount}} applied",
    "receiptCount_one": "{{count}} receipt",
    "receiptCount_other": "{{count}} receipts",
    "receiptsSummary_one": "{{count}} receipt, {{amount}}",
    "receiptsSummary_other": "{{count}} receipts, {{amount}}"
  },
  "share": {
    "title": "Share {{number}}",
    "body": "Anyone with the link can see this invoice as it is printed, without signing in.",
    "once": "The link is shown once, right after it is created. Revoking it stops it working at once.",
    "expiry": "Link stops working",
    "expiryHint": "After that it shows “This link is not available”.",
    "never": "Never",
    "days_one": "After {{count}} day",
    "days_other": "After {{count}} days",
    "create": "Create link",
    "linkLabel": "Share link",
    "copy": "Copy",
    "copied": "Link copied",
    "copiedShort": "Copied",
    "copyFailed": "The link couldn’t be copied. Select it and copy it with Ctrl+C.",
    "open": "Open",
    "onlyNow": "Copy it now: it won’t be shown again. To share the invoice again later, create a new link.",
    "active": "The invoice is shared by link",
    "created": "Created",
    "expires": "Stops working",
    "lastOpened": "Last opened",
    "notOpened": "Not opened yet",
    "opened": "Opened",
    "openedTimes_one": "{{n}} time",
    "openedTimes_other": "{{n}} times",
    "revoke": "Revoke link",
    "replace": "Create a new link and copy",
    "revokeTitle": "Revoke the link?",
    "replaceTitle": "Create a new link?",
    "revokeBody": "Whoever has the current link can no longer open the invoice.",
    "revoked": "Link revoked",
    "done": "Done",
    "wasRevoked": "The last link was revoked.",
    "wasExpired": "The last link has stopped working.",
    "onceActive": "For security the link is shown only when it’s created. To send it again, create a new link: the current one stops working.",
    "replaceBody": "The current link stops working: whoever has it can no longer open the invoice. The new link is copied, ready to send.",
    "replaceConfirm": "Create and copy",
    "replacedCopied": "New link copied",
    "body_quotation": "Anyone with the link can see this quotation as it is printed, without signing in.",
    "onlyNow_quotation": "Copy it now: it won’t be shown again. To share the quotation again later, create a new link.",
    "active_quotation": "The quotation is shared by link",
    "revokeBody_quotation": "Whoever has the current link can no longer open the quotation.",
    "replaceBody_quotation": "The current link stops working: whoever has it can no longer open the quotation. The new link is copied, ready to send."
  },
  "applyCredit": {
    "title": "Apply credit to {{number}}",
    "body": "Balance due {{amount}}. Apply the customer’s unapplied credit to it.",
    "fill": "Fill oldest first",
    "tableLabel": "The customer’s unapplied credit",
    "source": "Credit",
    "available": "Unapplied",
    "apply": "Apply",
    "applyFrom": "Amount to apply from {{number}}",
    "kind": {
      "RECEIPT": "Receipt",
      "CREDIT_NOTE": "Credit note"
    },
    "overSource": "More than is left on it.",
    "applying": "Applying",
    "left": "Left to pay",
    "overBalance": "The amounts add up to more than the balance due. Lower them.",
    "confirm": "Apply credit",
    "done": "{{amount}} applied to {{number}}",
    "none": "No unapplied credit.",
    "noneBody": "This customer has no receipts or credit notes with credit left to apply.",
    "truncated": "Only the oldest credit is listed. Apply it, then open this again for the rest."
  },
  "public": {
    "unavailableTitle": "This link is not available",
    "unavailableBody": "Ask the sender for a new link to this document.",
    "failedTitle": "The document couldn’t be loaded",
    "failedBody": "Check your connection and try again.",
    "retry": "Try again",
    "print": "Print",
    "language": "Language",
    "ready": "Ready to print"
  },
  "documents": {
    "open": "Open",
    "print": "Print",
    "duplicate": "Duplicate",
    "share": "Share",
    "refund": "Refund",
    "apply": "Apply",
    "remove": "Remove",
    "applications": "Invoices settled",
    "refunds": "Refunds drawn from it",
    "unappliedNotice": "Credit is left unapplied: apply it to open invoices, or refund it.",
    "removeNamed_receipt": "Remove {{invoice}} from this receipt",
    "removeNamed_creditNote": "Remove {{invoice}} from this credit note",
    "removeTitle_receipt": "Remove {{invoice}} from this receipt?",
    "removeTitle_creditNote": "Remove {{invoice}} from this credit note?",
    "removed": "{{invoice}} removed from {{number}}",
    "creditStamp": "Credit",
    "voucher": "Receipt voucher",
    "paymentVoucher": "Payment voucher",
    "noneVoid": "Nothing is applied: it is void.",
    "figures": "Figures",
    "invoiceCount_zero": "No invoices",
    "invoiceCount_one": "{{count}} invoice",
    "invoiceCount_other": "{{count}} invoices",
    "sourceCount_one": "From {{count}} credit",
    "sourceCount_other": "From {{count}} credits",
    "onAccount": "Held as credit on account",
    "fullyApplied": "Fully applied",
    "voidRefundFirst": "Void refund {{number}} drawn from it first.",
    "voidRemoveFirst_one": "Remove {{invoice}} first.",
    "voidRemoveFirst_other": "Remove the {{count}} invoices first.",
    "refundChequeNotCleared": "Cheque {{number}} has not cleared yet: refund once the bank pays it.",
    "methodFilter": "Filter by method",
    "allMethods": "All methods",
    "accountFilter": "Filter by cash or bank account",
    "allAccounts": "All accounts",
    "export": "Export",
    "exportHint_one": "Exports {{n}} document: this view, with its filters and order",
    "exportHint_other": "Exports {{n}} documents: this view, with its filters and order",
    "exported_one": "{{n}} document exported",
    "exported_other": "{{n}} documents exported",
    "exportedView": "The view was exported",
    "rowActions": "Actions for {{number}}",
    "lineCount_one": "{{count}} line",
    "lineCount_other": "{{count}} lines",
    "voucherCard": "Voucher",
    "asPrinted": "As printed"
  },
  "voucher": {
    "receiptTitle": "Receipt voucher",
    "refundTitle": "Payment voucher",
    "date": "Date",
    "receivedFrom": "Received from",
    "paidTo": "Paid to",
    "theSumOf": "The sum of",
    "method": "Method",
    "intoAccount": "Received into",
    "fromAccount": "Paid from",
    "reference": "Cheque or reference no.",
    "for": "Being payment of",
    "refundOf": "Being refund of",
    "onAccountOnly": "Payment on account",
    "onAccount": "Held on account as credit",
    "more_one": "+ {{count}} more document",
    "more_other": "+ {{count}} more documents",
    "receivedBy": "Received by",
    "paidBy": "Paid by",
    "voidBanner": "Void — this voucher is cancelled",
    "inWords": "In words",
    "paper": "Paper",
    "paperA5": "A5 landscape (voucher)",
    "paperA4": "A4 portrait"
  },
  "issuedPdf": {
    "title": "Issued PDFs",
    "loading": "Loading issued PDFs…",
    "loadFailed": "Issued PDFs could not be loaded.",
    "empty": "No PDF issued yet. Issue one to keep an exact copy.",
    "emptyVoid": "No PDF was issued for this invoice.",
    "issueLegend": "Issue a PDF of the invoice as it is now",
    "issue": {
      "en": "PDF (English)",
      "ar": "PDF (العربية)"
    },
    "language": {
      "en": "English",
      "ar": "Arabic"
    },
    "version": "Version {{version}}",
    "status": {
      "RENDERING": "Issuing",
      "ISSUED": "Issued",
      "FAILED": "Not produced",
      "PURGED": "File removed"
    },
    "failedNote": "This PDF could not be produced. Issue it again.",
    "purgedNote": "The file was removed under the data retention policy. Its SHA-256 is kept as proof.",
    "sha": "SHA-256",
    "copyHash": "Copy the SHA-256 of version {{version}} ({{language}})",
    "hashCopied": "SHA-256 copied",
    "copyFailed": "Could not copy. Select the code and copy it instead.",
    "download": "Download",
    "downloadNamed": "Download version {{version}} ({{language}})",
    "downloadIssued": "Download issued PDF",
    "retry": "Try again",
    "vsPrint": "An issued PDF is the exact copy you handed out. Print shows the invoice as it is now.",
    "state": {
      "issuing": "Issuing the PDF…",
      "rendering": "Preparing the PDF…",
      "slow": "Still preparing the PDF. This is taking longer than usual.",
      "done": "PDF downloaded.",
      "timeout": "The PDF is not ready yet. Try again in a minute.",
      "failed": "The PDF could not be produced.",
      "purged": "This PDF's file was removed under the data retention policy."
    }
  },
  "email": {
    "send": "Send by e-mail",
    "sendMenu": "Send by e-mail…",
    "title": "E-mail invoice {{number}}",
    "description": "The customer gets a short e-mail with the invoice attached as a PDF.",
    "to": "To",
    "toHint": "Press Enter or a comma after each address. Up to 5.",
    "noCustomerEmail": "The customer has no e-mail address on file. Type one.",
    "toRequired": "Add at least one address.",
    "cc": "Cc (optional)",
    "ccHint": "Copies go out as separate e-mails. Up to 5.",
    "toList": "Recipients",
    "ccList": "Copies",
    "removeAddress": "Remove {{address}}",
    "added": "Added {{address}}. Addresses: {{count}}.",
    "removed": "Removed {{address}}. Addresses: {{count}}.",
    "invalidAddress": "Not a valid e-mail address. Remove it or type it again.",
    "fixInvalid": "Fix or remove the addresses marked in red.",
    "language": "Language of the e-mail and the PDF",
    "languageHint": {
      "en": "E-mail and PDF in English",
      "ar": "E-mail and PDF in Arabic"
    },
    "languageName": {
      "en": "English",
      "ar": "Arabic"
    },
    "note": "Note to the customer (optional)",
    "noteCount": "{{count}} of {{max}} characters",
    "noteTooLong": "Keep the note under {{max}} characters.",
    "notReadyTitle": "E-mail is not set up for this company",
    "notReadyAdmin": "Set up how e-mail is sent in Settings, then come back to send it.",
    "notReadyAsk": "Ask an administrator to set up e-mail in Settings.",
    "openSettings": "Open e-mail settings",
    "sendFailed": "The e-mail was not sent",
    "cancel": "Cancel",
    "close": "Close",
    "sendAgain": "Send again",
    "steps": "Progress",
    "step": {
      "issuing": "Issuing PDF",
      "queued": "Queued",
      "sent": "Sent"
    },
    "overall": {
      "issuing": "Issuing the PDF…",
      "queued": "Queued. It goes out in a moment.",
      "sent": "Sent.",
      "partly": "Sent to some recipients only.",
      "notSent": "Not sent."
    },
    "status": {
      "QUEUED": "Queued",
      "SENDING": "Sending",
      "SENT": "Sent",
      "FAILED": "Not sent",
      "SUPPRESSED": "Suppressed"
    },
    "stillQueued": "Still queued. Delivery can take a few minutes.",
    "refresh": "Refresh",
    "openOutbox": "Open the outbox",
    "retryLoad": "Try again",
    "preview": {
      "title": "Preview",
      "subjectLabel": "Subject:",
      "subject": "Invoice {{number}} from {{company}}",
      "invoiceDate": "Invoice date",
      "dueDate": "Due date",
      "total": "Total",
      "balance": "Balance due",
      "currency": "OMR",
      "attachment": "Attached:",
      "wording": "The exact wording comes from your company's e-mail template."
    },
    "panel": {
      "title": "E-mails",
      "loading": "Loading e-mails…",
      "loadFailed": "E-mails could not be loaded.",
      "empty": "No e-mails sent yet.",
      "recipientRemoved": "Address removed",
      "retry": "Retry",
      "retryNamed": "Retry the e-mail to {{address}}",
      "retried": "Queued again.",
      "retryFailed": "Could not retry this e-mail."
    },
    "recipientLimit": "Up to {{max}} addresses. Remove one to add another.",
    "notAdded": "Not added: {{count}} more (the limit is {{max}})."
  },
  "salesperson": {
    "label": "Salesperson",
    "hint": "Credited with the sale for commission.",
    "customerDefault": "The customer’s salesperson",
    "none": "No salesperson",
    "placeholder": "Choose a salesperson",
    "search": "Search people",
    "empty": "No one found",
    "error": "The people could not be loaded",
    "quotationHint": "Carried to the invoice it converts to.",
    "creditNoteHint": "Whose commission this note reduces.",
    "fromInvoice": "Salesperson, from the invoice:",
    "mine": "My sales",
    "filter": "Salesperson",
    "all": "All salespeople",
    "chosen": "Chosen salesperson"
  }
}
